exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".group-title[data-v-832ac510]{display:flex;align-items:center;justify-content:space-between}.group-title__content[data-v-832ac510]{font-size:16px;font-weight:500;color:#262626;line-height:24px}.group-title[data-v-832ac510] .yxt-icon-close{cursor:pointer;padding:5px}\n", ""]);

